/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CompanyFields {
	Name = "Name",
	ShortName = "ShortName",
	BusinessId = "BusinessId",
	State = "State",
	Language = "Language",
	Roles = "Roles",
	Expertises = "Expertises",
	CustomerGroup = "CustomerGroup",
	IsElectronicCommunicationAllowed = "IsElectronicCommunicationAllowed",
	PostalAddress = "PostalAddress",
	VisitingAddress = "VisitingAddress",
	BillingAddress = "BillingAddress",
	Website = "Website",
	OnlineStore = "OnlineStore",
	Phone = "Phone",
	Email = "Email",
	Some = "Some",
	EstablishedAt = "EstablishedAt",
	TerminatedAt = "TerminatedAt",
	TerminationReason = "TerminationReason",
	HomeMunicipality = "HomeMunicipality",
	Municipality = "Municipality",
	District = "District",
	Type = "Type",
	TurnoverClass = "TurnoverClass",
	StaffSizeClass = "StaffSizeClass",
	TOL2008 = "TOL2008",
	ServiceDirectory = "ServiceDirectory",
	AssociationDirectory = "AssociationDirectory",
	Homeland = "Homeland",
	Description = "Description",
	ProductsAndServices = "ProductsAndServices",
	AdditionalInformation = "AdditionalInformation",
	DraftCompanyContactPersonFirstName = "DraftCompanyContactPersonFirstName",
	DraftCompanyContactPersonLastName = "DraftCompanyContactPersonLastName",
	DraftCompanyContactPersonTitle = "DraftCompanyContactPersonTitle",
	DraftCompanyContactPersonDateOfBirth = "DraftCompanyContactPersonDateOfBirth",
	DraftCompanyContactPersonPhoneNumber = "DraftCompanyContactPersonPhoneNumber",
	DraftCompanyContactPersonEmail = "DraftCompanyContactPersonEmail",
	DraftCompanyContactPersonLanguage = "DraftCompanyContactPersonLanguage",
	DraftCompanyContactReason = "DraftCompanyContactReason",
	CompanyUpdatePersonFirstName = "CompanyUpdatePersonFirstName",
	CompanyUpdatePersonSecondNames = "CompanyUpdatePersonSecondNames",
	CompanyUpdatePersonLastName = "CompanyUpdatePersonLastName",
	CompanyUpdatePersonTitle = "CompanyUpdatePersonTitle",
	CompanyUpdatePersonDateOfBirth = "CompanyUpdatePersonDateOfBirth",
	CompanyUpdatePersonEmails = "CompanyUpdatePersonEmails",
	CompanyUpdatePersonPhoneNumbers = "CompanyUpdatePersonPhoneNumbers",
	CompanyUpdatePersonLanguage = "CompanyUpdatePersonLanguage",
	CompanyUpdatePersonIsInfoUpdateRequestRecipient = "CompanyUpdatePersonIsInfoUpdateRequestRecipient",
	CompanyUpdatePersonIsVisiblePublicly = "CompanyUpdatePersonIsVisiblePublicly",
	CompanyUpdatePersonIsElectronicCommunicationAllowed = "CompanyUpdatePersonIsElectronicCommunicationAllowed",
}
